/**
 * Created by shaun on 16/09/2017.
 */

import {EMPTY, LOADING, READY, ERROR} from 'module/constants';
import common from 'module/common';
import {mapFieldMutation} from "module/mapField";

const SET_AVAILABLE_BRANCHES = 'setAvailableBranches';

const SET_SEARCH_LIST_STATE = 'setSearchListState';
const SET_SEARCH_LIST_SEARCH = 'setSearchListSearch';
const SET_SEARCH_LIST_BRANCHES = 'setSearchListBranches';
const SET_SEARCH_LIST_FILTERED_BRANCHES = 'setSearchListFilteredBranches';
const SET_ALL_BRANCH_REGIONS = 'branchRegions'

const SET_SELECTED_STATE = 'selectedState';
const SET_SELECTED = 'setSelected';
const GET_SELECTED_BRANCH = 'getSelected';
const GET_SELECTED_SHAREHOLDERS = 'getSelectedStakeholders';
const GET_BRANCH_LISTS = 'getBranchList'

let searchTimeout = null;

// initial state
const state = {
  listOfBranches: [],
  branchRegions:[],
  available: {
    state: EMPTY,
    branches: []
  },
  searchList: {
    state: EMPTY,
    search: {
      text: null,
      brand: null,
    },
    branches: [],
    filteredBranches: []
  },
  selected: {
    state: EMPTY,
    branch: {
      number: null,
      name: null,
      telephone: null,
      email: null,
      brand: {},
      organisationStructure: {
        region: null,
        localBusinessUnit: null,
        area: null,
        projectOffice: null
      },
      stakeholders: {
        manager: null,
        salesManager: null,
        businessUnitDirector: null,
        regionalDirector: null,
        areaManager: null,
        baChampion: null,
        tsm: null
      }
    }
  }
};

//actions
const actions = {
  search: _.debounce(({state, dispatch, commit, rootGetters}, {path, value, search}) => {
    if (search) {
      commit(SET_SEARCH_LIST_SEARCH, search);
    } else {
      search = _.cloneDeep(state.searchList.search);

      let searchField = _.last(path.split('.'));
      search[searchField] = value;

      commit(SET_SEARCH_LIST_SEARCH, search);
    }

    if (state.searchList.state === EMPTY) {
      commit(SET_SEARCH_LIST_STATE, LOADING);

      let idToken = rootGetters['user/idToken']();

      common
        .httpGet('branch')
        .idToken(idToken || null)
        .query({action: 'list'})
        .then((res) => {
          commit(SET_SEARCH_LIST_STATE, READY);
          commit(SET_SEARCH_LIST_BRANCHES, res.data);
          dispatch('filterSearchList');
        }, ({data}) => {
          commit(SET_SEARCH_LIST_STATE, ERROR);
        });
    } else {
      dispatch('filterSearchList');
    }
  }, 150),
  updateSearchFields({state, commit}, {brand, text}) {
    commit(SET_SEARCH_LIST_SEARCH, _.merge({}, state.searchList.search, {brand, text}));
  },
  filterSearchList({state, commit}) {
    let search = state.searchList.search;

    let filtered = state.searchList.branches;

    if (search.brand !== null) {
      filtered = filtered.filter(branch => branch.organisationStructure.brand === search.brand);
    }

    if (search.text !== null) {
      filtered = filtered.filter(branch => branch.label.toLowerCase().indexOf(search.text.toLowerCase()) >= 0);
    }

    commit(SET_SEARCH_LIST_FILTERED_BRANCHES, filtered);
  },
  select({state, dispatch, commit, rootGetters}, branchNumber) {
    let branchFromAvailable = state.available.branches.filter(branch => branch.number === branchNumber)[0];

    if (branchFromAvailable) {
      dispatch('selectFromObject', branchFromAvailable);
    } else {
      commit(SET_SELECTED_STATE, LOADING);

      let idToken = rootGetters['user/idToken']();

      let query = {action: 'fromBranchNumber', branch: branchNumber};

      common
        .httpGet('branch')
        .idToken(idToken || null)
        .query(query)
        .then((res) => {
          dispatch('addToAvailable', res.data);
          dispatch('selectFromObject', res.data);
        }, ({data}) => {
          commit(SET_SELECTED_STATE, ERROR);
        });
    }
  },
  async updateBranchRecord({ dispatch, commit, rootGetters }, payload) {
      const response = await common
        .httpPost('branch')
        .data({
          action: 'updateBranchRecord',
          selectedBranchName: payload.selectedBranchName,
          selectedBranchStakeholder: payload.selectedBranchStakeholder,
          selectedState: payload.selectedState,
          selectedEmail: payload.selectedEmail,
          selectedTelephone: payload.selectedTelephone,
          currentEmail: payload.currentEmail,
          selectedBranchRegion: payload.selectedBranchRegion,
          selectedBranchBusinessUnit: payload.selectedBranchBusinessUnit,
          branch:payload.branch,
        })
        .then((res) => {
          dispatch('initGetAllBranches');
          return response.data;
        }, (error) => {
          console.error('Error updating branch record:', error);
          throw error;
        })
  },
  selectFromObject({dispatch, commit}, branch) {
    commit(SET_SELECTED_STATE, READY);
    commit(SET_SELECTED, branch);
    dispatch('addToAvailable', branch);
  },
  addToAvailable({state, commit}, branchToAdd) {
    let availableBranches = state.available.branches.filter(branch => branch.number === branchToAdd.number);
    availableBranches.push(branchToAdd);
  },
  initGetAllBranches({commit, getters, dispatch, rootGetters}) {
    common
      .httpGet('branch')
      .query({action: 'listAllBranches' })
      .then((res) => {
        commit(GET_BRANCH_LISTS, res.data);
      }, (error) => {
        dispatch('error/error', error, {root: true});
      });
  },
  initGetAllBranchRegions({commit, getters, dispatch, rootGetters}) {
    common
      .httpGet('branch')
      .query({action: 'branchRegions' })
      .then((res) => {
        commit(SET_ALL_BRANCH_REGIONS, res.data);
      }, (error) => {
        dispatch('error/error', error, {root: true});
      });
  },
};

// Getters
const getters = {
  getSelected (){
    return state.selected.branch;
  },
  getBranchRegions(){
    return state.branchRegions ?? [];
  },
  getSelectedStakeholders(){
    return state.selected.branch.stakeholders;
  },
  getBranchesList () {
    return state.listOfBranches ?? [];
  }
};

// mutations
const mutations = {
  ...mapFieldMutation(),
  [SET_AVAILABLE_BRANCHES](state, branches) {
    state.available.state = READY;
    state.available.branches = branches;
  },
  [SET_SEARCH_LIST_STATE](state, newState) {
    state.searchList.state = newState;
  },
  [SET_SEARCH_LIST_SEARCH](state, search) {
    state.searchList.search = search;
  },
  [SET_SEARCH_LIST_BRANCHES](state, branches) {
    state.searchList.branches = branches;
  },
  [SET_SEARCH_LIST_FILTERED_BRANCHES](state, branches) {
    state.searchList.filteredBranches = branches;
  },
  [SET_SELECTED_STATE](state, newState) {
    state.selected.state = newState;
  },
  [SET_SELECTED_STATE](state, newState) {
    state.selected.state = newState;
  },
  [SET_SELECTED](state, branch) {
    state.selected.branch = branch;
  },
  [GET_BRANCH_LISTS](state, branchList) {
    state.listOfBranches = branchList;
  },
  [SET_ALL_BRANCH_REGIONS](state, limitation) {
    state.branchRegions = limitation;
  },
  [SET_AVAILABLE_BRANCHES](state, branches) {
    state.available.state = READY;
    state.available.branches = branches;
  },
};

export default {
  state,
  actions,
  getters,
  mutations
}